import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Styles need to be imported inline to place them in the back arrow component
import { KompisContentMargins } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { useState } from 'react';
import { styled } from 'styled-components';
import { GuidaExitPrompt } from '../components/GuidaExitPrompt';
import { GuidaMainHeader } from '../components/GuidaMainHeader';
import { GuidaMenu } from '../components/GuidaMenu';
import GuidaMenuButton from '../components/GuidaMenuButton';
import { useGuidaUIStates } from '../hooks/useGuidaUIStates';
const StyledContent = styled.main `
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: hidden;
  /* Ignore the kompis header margin */
  margin-top: -${props => props.$kompisHeaderMargin};

  /* Add the margin to height calculation due to flexbox */
  min-height: calc(100vh + ${props => props.$kompisHeaderMargin});
`;
export const GuidaLayout = ({ children, zipCodeOptions, activeShoppingCart, showCart, isRtl, onMenuOpen, isKiosk, kompisTranslations, settings, guidaHeaderSlot, cartUrl, storeSelectorOptions }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { zipCode = null, onZipCodeChange = () => { }, dexfApiKey = '' } = zipCodeOptions || {};
    const { storeId = null, stores = [], onStoreChange = () => { } } = storeSelectorOptions || {};
    const { isSidebarMode } = useGuidaUIStates();
    const getKompisHeaderMargin = () => (isSidebarMode ? '2.5rem' : '1.25rem');
    const onMenuButtonHandler = () => {
        setIsMenuOpen(true);
        onMenuOpen && onMenuOpen(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx(GuidaMainHeader, { settings: settings, kompisTranslations: kompisTranslations, activeShoppingBag: activeShoppingCart, disableLinks: isKiosk, showShoppingBag: showCart, theme: SkapaTheme, isRtl: isRtl, guidaSlot: guidaHeaderSlot, cartUrl: cartUrl, children: _jsx(GuidaMenuButton, { onClick: onMenuButtonHandler, buttonText: kompisTranslations.menu }) }), _jsx(GuidaMenu, { zipCodeOptions: { zipCode, onZipCodeChange, dexfApiKey }, storeSelectorOptions: {
                    storeId,
                    stores,
                    onStoreChange
                }, kompisTranslations: kompisTranslations, settings: settings, theme: SkapaTheme, isOpened: isMenuOpen, disableLinks: isKiosk, onClose: () => {
                    setIsMenuOpen(false);
                } }), _jsx(StyledContent, { "$kompisHeaderMargin": getKompisHeaderMargin(), id: 'guida-wrapper', "data-testid": 'guida-wrapper', children: _jsx(KompisContentMargins, { theme: SkapaTheme, children: children }) }), _jsx(GuidaExitPrompt, {})] }));
};
//# sourceMappingURL=GuidaLayout.js.map